import { getServerSession } from 'next-auth'

/**
 * Mocked database for development/testing purposes
 * Contains sample user data with basic fields
 */
export const mockedDatabase = {
  users: [
    {
      id: 0,
      name: 'Test User',
      email: 'test.user@1ocean.org',
      password: '1Ocean'
    },
    {
      id: 1,
      name: 'Ambra Cozzi',
      email: 'ambracozzi@1ocean.org',
      password: '1Ocean'
    },
    {
      id: 2,
      name: 'Elizaveta Borovenskaya',
      email: 'elizaveta.borovenskaya@1ocean.org',
      password: '1Ocean'
    },
    {
      id: 3,
      name: 'Antonio Russo',
      email: 'antonio.russo@rideonagency.com',
      password: '1Ocean'
    },
    {
      id: 4,
      name: 'Valeria Ceci',
      email: 'valeria.ceci@rideonagency.com',
      password: '1Ocean'
    },
    {
      id: 5,
      name: 'Marco Gregorin',
      email: 'marco.gregorin@rideonagency.com',
      password: '1Ocean'
    },
    {
      id: 6,
      name: 'Irene Iaccio',
      email: 'irene.iaccio@rideonagency.com',
      password: '1Ocean'
    }
  ]
}

/**
 * Finds a user by their email address
 * @param email - The email address to search for
 * @returns The matching user object or undefined if not found
 */
const getUserByEmail = async (email: string) => {
  return mockedDatabase.users.find(user => user.email === email) ?? null
}

/**
 * Finds a user by their ID
 * @param id - The user ID to search for
 * @returns The matching user object or undefined if not found
 */
const getUserById = async (id: number) => {
  return mockedDatabase.users.find(user => user.id === id) ?? null
}

/**
 * Gets the currently authenticated user from the session
 * @throws Error if no valid session or user email is found
 * @returns The current user object
 */
const getCurrentUser = async () => {
  const session = await getServerSession()

  if (!session || !session.user || !session.user.email) {
    return null
  }

  return getUserByEmail(session.user.email)
}

/**
 * Frozen object containing all user-related service methods
 */
export const UserService = Object.freeze({
  getUserByEmail,
  getUserById,
  getCurrentUser
})
